import * as chrono from 'chrono-node';
import { endOfDay, startOfDay } from 'date-fns';

export interface ParsedHumanDate {
  single?: Date;
  range?: { from: Date; to: Date };
}

/**
 * Thin wrapper over chrono-node.
 * - Returns a single day if only start found
 * - Returns a range if both start and end are present
 * No extra normalization beyond startOfDay/endOfDay boundaries.
 */
export function parseHumanDate(
  input: string,
  baseDate = new Date()
): ParsedHumanDate | null {
  const text = input.trim();
  if (!text) return null;
  const results = chrono.parse(text, baseDate);
  if (!results || results.length === 0) return null;
  const r = results[0];
  if (r.end) {
    const from = startOfDay(r.start.date());
    const to = endOfDay(r.end.date());
    return { range: { from, to } };
  }
  const single = startOfDay(r.start.date());
  return { single };
}
